export default "__VITE_ASSET__8fc821fb__"